<template>
    <div>
        <div v-if="this.getNotificationsEnabled">
            <b-form-group
                :description="$t('forms.notification-disable-description')">
                <label class="typo__label">{{ $t('select') }}</label>
                <multiselect v-model="disableNotificationsTypeSelected"
                             track-by="value"
                             :close-on-select="true"
                             :show-labels="false"
                             label="text"
                             placeholder="Select one"
                             :options="disableNotificationsTypeOptions"
                             :searchable="false"
                             :allow-empty="false">
                </multiselect>
            </b-form-group>

            <b-button variant="success" class="w-100" v-on:click="sendDisableNotificationsCommand">{{ $t('action-items.notifications-disable') }}</b-button>
        </div>
        <div v-if="!this.getNotificationsEnabled">
            <b-form-group
                :description="$t('forms.notification-enable-description')">
                <label class="typo__label">{{ $t('select') }}</label>
                <multiselect v-model="enableNotificationsTypeSelected"
                             track-by="value"
                             :close-on-select="true"
                             :show-labels="false"
                             label="text"
                             placeholder="Select one"
                             :options="enableNotificationsTypeOptions"
                             :searchable="false"
                             :allow-empty="false">
                </multiselect>
            </b-form-group>
            <b-button variant="success" class="w-100" v-on:click="sendEnableNotificationsCommand">{{ $t('action-items.notifications-enable') }}</b-button>
        </div>
    </div>
</template>

<script>
/*
DISABLE_HOST_NOTIFICATIONS
DISABLE_HOST_SVC_NOTIFICATIONS
ENABLE_HOST_NOTIFICATIONS
ENABLE_HOST_SVC_NOTIFICATIONS
 */
import Multiselect from "vue-multiselect";
import { useToast } from "vue-toastification";

export default {
    name: "HostNotifications",
    components: {Multiselect},
    data(){
        return {
            disableNotificationsTypeSelected: {
                value: 'hostOnly',
                text: this.$t('hosts.individual')
            },
            disableNotificationsTypeOptions: [
                {
                    value: 'hostOnly',
                    text: this.$t('hosts.individual')
                },
                {
                    value: 'hostAndServices',
                    text: this.$t('hosts.including-services')
                }
            ],
            enableNotificationsTypeSelected: {
                value: 'hostOnly',
                text: this.$t('hosts.individual')
            },
            enableNotificationsTypeOptions: [
                {
                    value: 'hostOnly',
                    text: this.$t('hosts.individual')
                },
                {
                    value: 'hostAndServices',
                    text: this.$t('hosts.including-services')
                }
            ],
        }
    },
    props: [
        'hostuuid',
        'notificationsEnabled'
    ],
    methods: {
        sendDisableNotificationsCommand: function(){
            let externalCommand = [
                {
                    command: 'submitDisableHostNotifications',
                    hostUuid: this.getUuid,
                    type:  this.disableNotificationsTypeSelected.value



                }
            ];
            this.sendCommand(externalCommand);
        },
        sendEnableNotificationsCommand: function(){
            let externalCommand = [
                {
                    command: 'submitEnableHostNotifications',
                    hostUuid: this.getUuid,
                    type: this.enableNotificationsTypeSelected.value
                }
            ];

            this.sendCommand(externalCommand);
        },
        sendCommand: function(externalCommand){
            axios.post('/hosts/external_commands.json', externalCommand)
                .then(response => {
                    useToast().success(this.$t('Command successfully sent'), {
                        timeout: 7000
                    });
                    this.$emit('refresh', 'notification')
                })
                .catch(error => {
                    useToast().error(this.$t('error'), {
                        timeout: 2000
                    });
                });
        },
    },
    computed: {
        getUuid: function(){
            return this.hostuuid;
        },
        getNotificationsEnabled: function(){
            return this.notificationsEnabled;
        }
    }
}
</script>

<style scoped>

</style>
